<template>
    <base-modal
        :title="'Ruta: ' + route.name"
        size="lg"
        :show-confirm-button="false"
        cancel-text="Cerrar"
        @close="close"
    >
        <table class="table table-md text-center align-middle">
            <thead>
                <tr>
                    <th scope="col">{{ headerTitle }}</th>
                    <th v-if="route.type !== 'courses'" scope="col">{{ secondHeaderTitle }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in displayItems" :key="index">
                    <td>
                        <p class="m-0" :class="{ 'small': route.type === 'courses' }">
                            {{ getItemName(item) }}
                        </p>
                    </td>
                    <td v-if="route.type !== 'courses'">
                        <p class="m-0">{{ getItemSecondary(item) }}</p>
                    </td>
                </tr>
            </tbody>
        </table>
    </base-modal>
</template>

<script>
import BaseModal from './BaseModal.vue';

export default {
    name: 'ModalShowInfo',
    components: { BaseModal },
    props: {
        route: { type: Object, required: true }
    },
    computed: {
        displayItems() {
            const typeMap = {
                courses: this.route.courses || [],
                students: this.route.students || [],
                badges: this.route.badges || []
            };
            return typeMap[this.route.type] || [];
        },
        headerTitle() {
            const titles = {
                courses: 'Cursos',
                students: 'Usuario',
                badges: 'Usuario'
            };
            return titles[this.route.type] || 'Información';
        },
        secondHeaderTitle() {
            return this.route.type === 'students' ? 'Email' : 'Fecha de Insignía';
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        getItemName(item) {
            if (this.route.type === 'courses') {
                return item.wordpress_course_title;
            }
            return `${item.firstname} ${item.lastname}`;
        },
        getItemSecondary(item) {
            return this.route.type === 'students' ? item.email : item.created_at;
        }
    }
};
</script>
